import { Navigate } from "react-router-dom";

/** Old roster URL; the combined Daily thalis screen lives at /fmbThaliDelivery. */
export default function FmbThaliDistributionDailyRunList() {
  return <Navigate to="/fmbThaliDelivery" replace />;
}
